import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    map: require('lodash/map'),
};

const ChannelActions = require('../../actions/ChannelActions');
const ChannelStore = require('../../stores/channel_store_reflux');

const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');


import SortableTableClassic from '../table/SortableTableClassic';
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    channelId: PropTypes.number.isRequired,
    orgName: PropTypes.string.isRequired,
    className: PropTypes.string,
    heading: PropTypes.string,
};

const defaultProps = {
    className: '',
    heading: 'Chatbot Usage Statistics',
};

class ChatbotUsageView extends React.Component {
    constructor(props) {
        super(props);
        let chatbotUsage = ChannelStore.getStateChannel(props.channelId).chatbotUsage;
        const projectStoreState = ProjectStore.getState();
        const projects = projectStoreState.initialized ? projectStoreState.projects : null;
        const shortCourseProjects = projectStoreState.initialized ? projectStoreState.shortCourseProjects : null;
        
        this.state = {
            actionId: null,
            projectActionId: null,
            chatbotUsage,
            projects,shortCourseProjects,
        };
        this.unsubscribes = [
            ChannelStore.listen(this.onStoreChange),
            ProjectStore.listen(this.onStoreChange),
        ];
    }
    
    componentDidMount() {
        let actionId = null;
        let projectActionId = null;
        if (!this.state.chatbotUsage) {
            actionId = uuid.v4();
        }
        if (!this.state.projects) {
            projectActionId = uuid.v4();
        }
        this.setState({actionId,projectActionId, error:null},()=>{
            if (actionId) {
                ChannelActions.adminGetChatbotUsage(actionId,this.props.channelId);
            }
            if (projectActionId) {
                ProjectActions.getAllProjects(projectActionId);
            }
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onRefresh=()=>{
        let actionId = uuid.v4();
        this.setState({actionId, error:null},()=>{
            ChannelActions.adminGetChatbotUsage(actionId,this.props.channelId);
        });
    }
    
    onStoreChange=(storeState)=>{
        if (storeState.action.id === this.state.actionId) { 
            if (storeState.action.error) {
                this.setState({error: storeState.action.error, actionId: null});
            }
            else {
                let chatbotUsage = ChannelStore.getStateChannel(this.props.channelId).chatbotUsage || [];
                this.setState({chatbotUsage, actionId: null, error: null});
            }
        };
        if (storeState.action.id === this.state.projectActionId) {
            if (storeState.action.error) {
                this.setState({projectError: storeState.action.error, projectActionId: null});
            }
            else {
                const projectStoreState = ProjectStore.getState();
                const projects = projectStoreState.projects || [];
                const shortCourseProjects = projectStoreState.shortCourseProjects || [];
                this.setState({projects, shortCourseProjects, projectActionId:null});
            }
        }
    }
    
    render() {
        if (this.state.error) {
            return (
                <ErrorBox error={this.state.error} />
            )
        }
        if (this.state.projectError) {
            return (
                <ErrorBox error={this.state.projectError} />
            )
        }
        if (!this.state.chatbotUsage || !this.state.projects) {
            return <LoadingMainContent/>
        }
        let { activityUsage, shortCourseUsage } = this.state.chatbotUsage;
        const projects = this.state.projects;
        const shortCourseProjects = this.state.shortCourseProjects;
        activityUsage = _.map(activityUsage,(row)=>{
            let project = _.find(projects,{id: Number(row.project_id)});
            let project_name = project ? project.name : '';
            return {...row, project_name};
        });
        shortCourseUsage = _.map(shortCourseUsage,(row)=>{
            let project = _.find(shortCourseProjects,{id: Number(row.project_id)});
            let project_name = project ? project.name : '';
            return {...row, project_name};
        });
        
        return (
            <div>
                <SortableTableClassic
                    title="Chatbot Activity Usage"
                    totalName="Rows"
                    additionalTotalRowKeys={["calls","input_tokens","output_tokens"]}
                    onRefresh={this.onRefresh}
                    refreshDisabled={!!this.state.actionId}
                    formatTotals
                    uniqueRowKey="id"
                    rows={activityUsage}
                    columns={
                        [
                            {
                                displayName: 'Year and Month',
                                key:'ym',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'project',
                                key:'project_name',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'activity',
                                key:'title',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'share',
                                key:'share_id',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'model',
                                key:'model',
                                size: 5,
                                type: 'string'
                            },
                            {
                                displayName: 'Calls',
                                key:'calls',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Input Tokens',
                                key:'input_tokens',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Output Tokens',
                                key:'output_tokens',
                                size: 2,
                                type: 'number'
                            },
                        ]
                    }
                    displayColumnCallbacksRow={{
                        title: (row) => {
                            let url = `/project/${this.props.channelId}/${row.project_id}/activity/${row.activity_id}`;
                            return (
                                <a className="trad-link" href={url}>
                                    {row.title}
                                </a>
                            );
                        },
                        input_tokens: (row) => {
                            return Number(row.input_tokens).toLocaleString();
                        },
                        output_tokens: (row) => {
                            return Number(row.output_tokens).toLocaleString();
                        },
                    }}
                />
                <SortableTableClassic
                    title="Chatbot Short Course Usage"
                    totalName="Rows"
                    additionalTotalRowKeys={["calls","input_tokens","output_tokens"]}
                    onRefresh={this.onRefresh}
                    refreshDisabled={!!this.state.actionId}
                    formatTotals
                    uniqueRowKey="id"
                    rows={shortCourseUsage}
                    columns={
                        [
                            {
                                displayName: 'Year and Month',
                                key:'ym',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'project',
                                key:'project_name',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'short course',
                                key:'title',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'model',
                                key:'model',
                                size: 5,
                                type: 'string'
                            },
                            {
                                displayName: 'Calls',
                                key:'calls',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Input Tokens',
                                key:'input_tokens',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Output Tokens',
                                key:'output_tokens',
                                size: 2,
                                type: 'number'
                            },
                        ]
                    }
                    displayColumnCallbacksRow={{
                        title: (row) => {
                            let url = `/project/${this.props.channelId}/${row.project_id}/short_course/${row.short_course_id}`;
                            return (
                                <a className="trad-link" href={url}>
                                    {row.title}
                                </a>
                            );
                        },
                        input_tokens: (row) => {
                            return Number(row.input_tokens).toLocaleString();
                        },
                        output_tokens: (row) => {
                            return Number(row.output_tokens).toLocaleString();
                        },
                    }}
                />
            </div>
        )
    } // render
}

ChatbotUsageView.propTypes = propTypes;
ChatbotUsageView.defaultProps = defaultProps;

export default ChatbotUsageView;